import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Row,
  Col,
  Card,
  Typography,
  InputNumber,
  Form,
  Badge,
  Modal,
  Spin,
} from "antd";
import {
  DollarOutlined,
  ArrowLeftOutlined,
  EditOutlined,
  GiftOutlined,
} from "@ant-design/icons";
import { Container, Header, StyledCard, BonusCard, CardBuy } from "./styles";
import { HeaderTitle, InputTel, ViewInput } from "../../../GlobalStyles";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { getValue } from "../../../services/functions";
import { MdHistory } from "react-icons/md";
import { useAuth } from "../../../hooks/AuthContext";

const { Title, Text, Paragraph } = Typography;

const AdicionarSaldo = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [cpf, setCpf] = useState("");
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [packages, setPackages] = useState([]);

  useEffect(() => {
    listPackages();
  }, []);

  async function listPackages() {
    await api
      .get(`/packages`)
      .then((response) => {
        setPackages(response.data);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }
  const showModal = (pkg) => {
    setSelectedPackage(pkg);
    setCpf("");
    setIsModalVisible(true);
  };

  async function createDeposit() {
    setIsLoadingModal(true);
    await api
      .post(`/deposit`, {
        package_id: selectedPackage.id,
        cpf: cpf,
      })
      .then((response) => {
        navigate(`/cliente/pagamento/${response.data.id}`);
        toast.success(
          "QRCode gerado com sucesso, efetue o pagamento para confirmar seu deposito"
        );
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingModal(false);
  }

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const renderCard = (pkg) => {
    if (pkg.bonus) {
      return (
        <Badge.Ribbon
          text={
            <p style={{ color: "#000" }}>{`+ ${getValue(
              pkg.bonus || 0
            )} Bônus`}</p>
          }
          style={{
            background: "#FFF",
          }}
        >
          <BonusCard className={pkg.type} onClick={() => showModal(pkg)}>
            <div className="icon-wrapper">
              <GiftOutlined />
            </div>
            <Title level={4}>{pkg.name}</Title>
            <Text>{pkg.description}</Text>
            <Title level={2} className="price">
              {getValue(pkg.value || 0)}
            </Title>
          </BonusCard>
        </Badge.Ribbon>
      );
    }

    return (
      <CardBuy className={pkg.type} onClick={() => showModal(pkg)}>
        <div className="icon-wrapper">
          <DollarOutlined />
        </div>
        <Title level={4}>{pkg.name}</Title>
        <Text>{pkg.description}</Text>
        <Title level={2} className="price">
          {getValue(pkg.value || 0)}
        </Title>
      </CardBuy>
    );
  };

  return (
    <Container>
      <HeaderTitle>
        <h1>Selecionar Pacote</h1>
        <Button
          type="primary"
          style={{
            borderRadius: 50,
          }}
          onClick={() => {
            navigate("/cliente/depositos");
          }}
        >
          <MdHistory size="20" color="#fff" />
          <span>Historico de Depositos</span>
        </Button>
      </HeaderTitle>

      {isLoading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Row
            gutter={[24, 24]}
            style={{
              marginTop: 20,
            }}
          >
            {packages.map((pkg) => (
              <Col xs={24} sm={12} md={8} key={pkg.title}>
                {renderCard(pkg)}
              </Col>
            ))}
          </Row>
        </>
      )}

      {selectedPackage && (
        <Modal
          title="Confirmar Seleção"
          open={isModalVisible}
          isLoading={isLoadingModal}
          onOk={() => {
            createDeposit();
          }}
          onCancel={handleCancel}
          okText="Confirmar e ir para Pagamento"
          cancelText="Cancelar"
        >
          <Paragraph
            style={{
              marginBottom: 0,
            }}
          >
            Você selecionou o seguinte item:
          </Paragraph>
          <Title
            level={5}
            style={{
              marginTop: 10,
            }}
          >
            {selectedPackage.name}
          </Title>
          <Paragraph> {selectedPackage.description}</Paragraph>
          <Text>Valor a pagar: </Text>
          <Text strong>{getValue(selectedPackage.value || 0)}</Text>
          {!!selectedPackage.bonus && (
            <>
              <br />
              <Text>Bônus: </Text>
              <Text strong>{getValue(selectedPackage.bonus || 0)}</Text>
              <br />
              <Text>Total a ser creditado: </Text>
              <Text strong>
                {getValue(selectedPackage.value + selectedPackage.bonus || 0)}
              </Text>
            </>
          )}
          <Paragraph style={{ marginTop: 20 }}>
            Um QR Code PIX será gerado para o pagamento.
          </Paragraph>
          {!user?.costumer_id && (
            <ViewInput
              style={{
                marginBottom: 25,
              }}
            >
              <p>CPF ( Digite o seu cpf para gerar os pagamentos via pix )</p>
              <InputTel
                mask="999.999.999-99"
                maskChar=""
                noSpaceBetweenChars={true}
                placeholder="cpf"
                value={cpf}
                onChange={(event) =>
                  setCpf(event.target.value.replace(/[^0-9]/g, ""))
                }
              />
            </ViewInput>
          )}
        </Modal>
      )}
    </Container>
  );
};

export default AdicionarSaldo;
